import { Box, Heading, Image, Stack, Text, Tabs, TabPanels, TabPanel } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
export default function Backend(props) {
    const [showTheOrange, setshowTheOrange] = useState(false);
    useEffect(() => {
      setTimeout(() => {
        setshowTheOrange(true);
      }, 500);
    }, [])
    
    return (
        <Stack>
            <Tabs borderColor={'primaryBlue.100'}>
              

                <TabPanels pt={4}>
                    <TabPanel display={'flex'} height={'-webkit-fit-content'} alignItems={'baseline'} flexWrap={'wrap'} gap={4} spacing={'0'}>
                        <Stack direction={'row'}></Stack>
                        {
                            Object.values(props).map((v, i) => {
                                return (
                                    (i >= 0 && i <= 11) &&
                                    <Stack
                                        w={'23%'}
                                        key={i}
                                        pb={4}
                                       
                                    >
                                        <Stack
                                            position={'relative'}
                                           
                                            _before={{
                                                content: '""',
                                                w: '100%',
                                                h: showTheOrange ? { base: '160px', lg: '250px' } : '0px',
                                                left: 0,
                                                bottom: 0,
                                                bgColor: 'primaryOrange.100',
                                                position: 'absolute',
                                                zIndex: -1,
                                                borderRadius: 10,
                                                transition: '0.3s'
                                            }}
                                            gap={'10'}
                                        >
                                            <Image
                                                src={v.image}
                                                alt={v.name}
                                                w={'200px'}
                                                marginX={'auto'}
                                            />
                                        </Stack>
                                        <Stack
                                            direction={'row'}
                                            alignItems={'flex-end'}
                                            px={4}
                                            justifyContent={'space-between'}
                                        >
                                            <Box>
                                                <Heading
                                                    pt={4}
                                                    color={'bgGrays.100'}
                                                    fontWeight={600}
                                                    fontSize={19}
                                                >
                                                    {v.name}
                                                </Heading>
                                                <Text
                                                    color={'primaryOrange.100'}
                                                    fontWeight={600}
                                                    fontSize={14}
                                                >
                                                    {v.designation}
                                                </Text>
                                            </Box>
                                            {/* <Box>
                                                <Link><Icon as={FaLinkedinIn} color={'#007AB9'} fontSize={24} /></Link>
                                            </Box> */}
                                        </Stack>
                                    </Stack>
                                )
                            })
                        }
                    </TabPanel>
                  
                </TabPanels>
            </Tabs>
        </Stack>
    )
}
